module.exports = __webpack_public_path__ + "img/filedefault.af8b87e9.jpg";